export const WHATS_NEW_SETTING_KEY = 'whatsNew.lastSeenVersion';
export const WHATS_NEW_MANUAL_TRIGGER_KEY = 'whatsNew.manualTrigger';
export const WHATS_NEW_AUTO_POPUP_DISABLED_KEY = 'whatsNew.autoPopupDisabled';
